export default "__VITE_ASSET__B3YK$T4a__"